import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

@Component({
  selector: "field-set-older-than-age",
  templateUrl: "./field-set-older-than-age.component.html",
  styles: [],
})
export class FieldSetOlderThanAgeComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }
}
